import { convertStyleData, transformPx2Rem } from '@utils/tools';

import './NewCountCustomComponent.less';

export default function NewCountCustomComponent(props) {
  /**
   * 传入数据
   */ 
  const data = props.data;                // 组件数据
  const detailData = props.detailData;    // 详情页数据
  const dynamicData = props.dynamicData;  // 动态数据
  /**
   * 组件配置对象
   */  
  const customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  const styleObj = convertStyleData(data.style);
  const imgStyleObj = convertStyleData({
    width: customFeature.size,
    height: customFeature.size
  })
  /**
   * 组件内容处理
   */   
  let imgUrl = null;
  let todayCount = 0;
  let allCount = 0;
  let counted = false;
  if (customFeature.type === 0)  {
    if (customFeature.va == 0 && customFeature.effect == 1) {
      counted = todayCount > 0;
    } else {
      counted = allCount > 0;
    }
  }
  imgUrl = counted ? customFeature.voteChangePicture : customFeature.voteInitPicture;
  let count = '';
  /**
   * 返回组件
   */
  return (
    <div className="custom-component new-count" style={styleObj}>
      <div className="new-count-ele">
        {customFeature.isShowImage && 
          <img className="new-count-image" src={imgUrl} style={imgStyleObj}/>
        }
        <span className="new-count-content">{data.content}{count}</span>
      </div>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/custom-component/new-count-custom-component/NewCountCustomComponent.jsx